import moment from "moment";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from 'react-redux';
import { slugsSelector } from '../selectors/slugs';
import { hydrateSlugs } from '../actions/slugs/slugsActions';


function isExpired(expires) {
    return !expires || moment(expires).isBefore();
}

export function useSlugLookup(slug) {
    const dispatch = useDispatch();
    const slugState = useSelector(slugsSelector);
    //reducers aren't even loaded therefore just give up.
    if(!slugState){
        return {loaded: true}
    }
    const {loading, loaded, data} = slugState;

    if(!loading && isExpired(data?.expires)) {
        dispatch(hydrateSlugs());
    }

    const slugData = data?.slugs[slug];
    if(isEmpty(slugData)) {
        return {loaded};
    }
    return {locationId: slugData?.location_id, locationType: slugData?.location_type, loaded};
}
